export const XROSSOVER_APP_LOGIN = 'https://app.xrossoversports.com/#/login';
export const XROSSOVER_APPSTORE_APP = 'https://apps.apple.com/us/app/xover-trainer/id1640546882'
export const XROSSOVER_LEGACY_STORE = 'https://app.xrossoversports.com/#/login';